import React from "react";
import "./services.scss";

const Services = () => {
  return (
    <div className="services-section">
      <div className="services-container">
        <div className="services-icons">
          <div className="service-item">
            <img src="/strategy.webp" alt="Strategy Icon" className="icon" />
            {/* <p>Strategy</p> */}
          </div>
          <div className="service-item">
            <img src="/design.webp" alt="Design Icon" className="icon" />
            {/* <p>Design</p> */}
          </div>
          <div className="service-item">
            <img src="/dev.webp" alt="Development Icon" className="icon" />
            {/* <p>Development</p> */}
          </div>
        </div>
        <div className="services-text">
          <h2>Our services.</h2>
          <h3>Design-led digital products.</h3>
          <p>
          Arrow Digital's digital marketing services are designed to help businesses grow through data-driven strategies. From SEO, PPC, and social media marketing to content creation and email campaigns, we craft tailored solutions that boost visibility, engage audiences, and drive conversions. With over 25 years of expertise, we ensure brands achieve measurable success in an ever-evolving digital landscape.
          </p>
          <a href="/services" className="services-link">
            Go to services ➔
          </a>
        </div>
      </div>
    </div>
  );
};

export default Services;
